module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create_pjt"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "pjt_type"
  }, [_c('p', [_vm._v("项目类型")]), _vm._v(" "), _c('div', {
    staticClass: "picker",
    on: {
      "click": _vm.typeShow
    }
  }, [_c('span', {
    ref: "types",
    staticClass: "vals"
  }, [_vm._v(_vm._s(_vm.selectProject.projectTypeName) + " " + _vm._s(_vm.selectProject.projectType2Name))]), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "popup",
    attrs: {
      "position": "bottom",
      "closeOnClickModal": false
    },
    model: {
      value: (_vm.TypePopup),
      callback: function($$v) {
        _vm.TypePopup = $$v
      },
      expression: "TypePopup"
    }
  }, [_c('div', {
    staticClass: "picker-toolbar"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.typeHiden
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm",
    on: {
      "click": _vm.confirmtype
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('mt-picker', {
    staticClass: "typepicker",
    attrs: {
      "slots": _vm.typeSlots,
      "visible-item-count": 3
    },
    on: {
      "change": _vm.ontypeChange
    }
  }), _vm._v(" "), _c('mt-picker', {
    staticClass: "typepickerone",
    attrs: {
      "slots": _vm.typeSlotsone,
      "visible-item-count": 3
    },
    on: {
      "change": _vm.ontypeoneChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "need_label"
  }, [_c('div', {
    ref: "skillWrap",
    staticClass: "labels"
  }, _vm._l((_vm.skillArr), function(skillArr, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(skillArr))])
  }), 0), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "primary",
      "id": "select_skill"
    },
    on: {
      "click": _vm.labelShow
    }
  }, [_vm._v("选择项目所需技能")])], 1), _vm._v(" "), _c('mt-popup', {
    staticClass: "showLabels",
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.labelPopup),
      callback: function($$v) {
        _vm.labelPopup = $$v
      },
      expression: "labelPopup"
    }
  }, [_c('div', {
    staticClass: "label_wrap"
  }, [_c('div', {
    staticClass: "label_title"
  }, [_c('a', {
    staticClass: "label_cancel",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.labelHiden
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', [_vm._v("选择技能标签")]), _vm._v(" "), _c('a', {
    staticClass: "label_save",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.labelSave
    }
  }, [_vm._v("完成")])]), _vm._v(" "), _c('ul', {
    staticClass: "label_val"
  }, _vm._l((_vm.skills), function(ref) {
    var value = ref.value;
    var key = ref.key;

    return _c('li', {
      key: key,
      ref: "skillsName",
      refInFor: true,
      attrs: {
        "value": key
      },
      on: {
        "click": function($event) {
          return _vm.toggle()
        }
      }
    }, [_c('span', [_vm._v(_vm._s(value))]), _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "label_add",
    on: {
      "click": _vm.labelSave
    }
  }, [_vm._v("确认添加")])])]), _vm._v(" "), _c('div', {
    staticClass: "pjt_title"
  }, [_c('p', [_vm._v("项目标题")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "一句话概括你要做什么? 比如:机械设计图纸",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pjt_describe"
  }, [_c('p', [_vm._v("项目描述")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.describeShow($event)
      }
    }
  }, [_vm._v("项目描述怎么写?"), _c('icon', {
    staticClass: "info-circle",
    attrs: {
      "name": "info-circle"
    }
  })], 1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.describeVal),
      expression: "describeVal"
    }],
    staticClass: "describe_val",
    attrs: {
      "rows": "5",
      "placeholder": "详细描述你的项目需求以及对人员的期望，让专家更全面的了解你想要什么。一、项目描述：二、主要功能点：三、可参考产品：四、人员要求"
    },
    domProps: {
      "value": (_vm.describeVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.describeVal = $event.target.value
      }
    }
  })], 1), _vm._v(" "), _c('mt-popup', {
    staticClass: "describe_wrap",
    attrs: {
      "position": "right"
    },
    model: {
      value: (_vm.describe),
      callback: function($$v) {
        _vm.describe = $$v
      },
      expression: "describe"
    }
  }, [_c('mt-header', {
    attrs: {
      "title": "项目描述"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": _vm.describeHiden
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    ref: "contract",
    staticClass: "contract"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "add_img"
  }, [_vm._l((_vm.imgurl), function(imgurl, index) {
    return _c('div', {
      key: index,
      staticClass: "imgs"
    }, [_c('icon', {
      attrs: {
        "name": "times-circle"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deletePhoto(imgurl.resId)
        }
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": imgurl.fullPath
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "add_btn",
    on: {
      "click": _vm.addSave
    }
  }, [_c('icon', {
    attrs: {
      "name": "camera"
    }
  }), _vm._v(" "), _c('p', [_vm._v("添加图片")])], 1), _vm._v(" "), _c('input', {
    ref: "upDataPart",
    attrs: {
      "id": "upDataPart",
      "type": "file",
      "multiple": "",
      "accept": "image/*",
      "value": "上传",
      "enctype": "multipart/form-data"
    },
    on: {
      "change": function($event) {
        return _vm.onFormChange($event)
      }
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "money"
  }, [_c('p', [_vm._v("项目预算")]), _vm._v(" "), _c('strong', [_vm._v("您的预算是?")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "moneyPicker"
    },
    on: {
      "click": _vm.moneyShow
    }
  }, [_c('strong', [_vm._v("￥")]), _vm._v(" "), _c('span', {
    ref: "moneyVal"
  }, [_vm._v(_vm._s(_vm.selectProject.prePriceName))]), _vm._v(" "), _c('div', {
    staticClass: "triangle"
  })])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "popup",
    attrs: {
      "position": "bottom",
      "closeOnClickModal": false
    },
    model: {
      value: (_vm.moneyPopup),
      callback: function($$v) {
        _vm.moneyPopup = $$v
      },
      expression: "moneyPopup"
    }
  }, [_c('div', {
    staticClass: "picker-toolbar"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.moneyHiden
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm",
    on: {
      "click": _vm.confirmMoney
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('mt-picker', {
    staticClass: "moneyPickerWrap",
    attrs: {
      "slots": _vm.moneySlots,
      "visible-item-count": 3
    },
    on: {
      "change": _vm.onMoneyChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('p', [_vm._v("项目周期")]), _vm._v(" "), _c('strong', [_vm._v("预计交付在?")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "timePicker"
    },
    on: {
      "click": _vm.timeShow
    }
  }, [_c('span', {
    ref: "timeVal"
  }, [_vm._v(_vm._s(_vm.selectProject.periodName))]), _c('div', {
    staticClass: "triangle"
  })])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "popup",
    attrs: {
      "position": "bottom",
      "closeOnClickModal": false
    },
    model: {
      value: (_vm.timePopup),
      callback: function($$v) {
        _vm.timePopup = $$v
      },
      expression: "timePopup"
    }
  }, [_c('div', {
    staticClass: "picker-toolbar"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.timeHiden
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm",
    on: {
      "click": _vm.confirmtime
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('mt-picker', {
    staticClass: "pickerWrap",
    attrs: {
      "slots": _vm.timeSlots,
      "visible-item-count": 3
    },
    on: {
      "change": _vm.onTimeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "industry"
  }, [_c('p', [_vm._v("所属行业")]), _vm._v(" "), _c('div', {
    staticClass: "industryPicker",
    on: {
      "click": _vm.industryShow
    }
  }, [_c('span', {
    ref: "industryVal"
  }, [_vm._v(_vm._s(_vm.selectProject.industryName))]), _c('div', {
    staticClass: "triangle"
  })])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "popup",
    attrs: {
      "position": "bottom",
      "closeOnClickModal": false
    },
    model: {
      value: (_vm.industryPopup),
      callback: function($$v) {
        _vm.industryPopup = $$v
      },
      expression: "industryPopup"
    }
  }, [_c('div', {
    staticClass: "picker-toolbar"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.industryHiden
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm",
    on: {
      "click": _vm.confirmIndustry
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('mt-picker', {
    staticClass: "pickerWrap",
    attrs: {
      "slots": _vm.industrySlots,
      "visible-item-count": 3
    },
    on: {
      "change": _vm.onIndustryChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "city"
  }, [_c('p', [_vm._v("所在城市")]), _vm._v(" "), _c('div', {
    staticClass: "cityPicker",
    on: {
      "click": _vm.cityShow
    }
  }, [_c('span', {
    ref: "cityVal"
  }, [_vm._v(_vm._s(_vm.selectProject.cityName))]), _c('div', {
    staticClass: "triangle"
  })])]), _vm._v(" "), _c('mt-popup', {
    staticClass: "popup",
    attrs: {
      "position": "bottom",
      "closeOnClickModal": false
    },
    model: {
      value: (_vm.cityPopup),
      callback: function($$v) {
        _vm.cityPopup = $$v
      },
      expression: "cityPopup"
    }
  }, [_c('div', {
    staticClass: "picker-toolbar"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cityHiden
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm",
    on: {
      "click": _vm.confirmCity
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('mt-picker', {
    staticClass: "pickerWrap",
    attrs: {
      "slots": _vm.citySlots,
      "visible-item-count": 3
    },
    on: {
      "change": _vm.onCityChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "company_name"
  }, [_c('p', [_vm._v("企业名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:0|max:20'),
      expression: "'required|min:0|max:20'"
    }],
    attrs: {
      "type": "text",
      "placeholder": "如果是公司发布项目，请输入公司名称(选填)"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "who"
  }, [_c('p', [_vm._v("倾向让谁完成项目")]), _vm._v(" "), _vm._l((_vm.who), function(who, index) {
    return _c('span', {
      key: index,
      class: {
        select: _vm.actWho == who.type
      },
      on: {
        "click": function($event) {
          return _vm.selected(who)
        }
      }
    }, [_vm._v(_vm._s(who.key))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "fapiao"
  }, [_c('p', [_vm._v("是否要发票")]), _vm._v(" "), _vm._l((_vm.invoice), function(invoice, index) {
    return _c('span', {
      key: index,
      class: {
        select: _vm.actInvoice == invoice.type
      },
      on: {
        "click": function($event) {
          return _vm.selectInvoice(invoice)
        }
      }
    }, [_vm._v(_vm._s(invoice.key))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "release_btn",
    on: {
      "click": _vm.sumbitProject
    }
  }, [_vm._v("发布新任务")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae2081f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/create_pjt.vue
// module id = 1258
// module chunks = 1